import { Typography, IconButton } from '@mui/material';
import { Edit, Delete, People } from '@mui/icons-material';

import { formatToLocalDateTimeShort } from '../../../../utils/dateFormatter';

import './UsersTable.css';
import { UsersTableProps } from './UsersTable.types';

export function UsersTable({ users, roleLabels, isLoading, onEdit, onDelete, bodyRef }: UsersTableProps) {
  if (users.length === 0) {
    return (
      <div className="users-table-no-data">
        <People className="users-table-no-data-icon" />
        <Typography>Користувачів не знайдено</Typography>
      </div>
    );
  }

  return (
    <div className="users-table-wrapper" ref={bodyRef}>
      <table className="users-table">
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="users-table-row">
              <td className="users-table-cell um-col-email">{user.email}</td>
              <td className="users-table-cell um-col-name">{user.display_name}</td>
              <td className="users-table-cell um-col-role">
                <span className="users-table-role-badge">{roleLabels[user.role]}</span>
              </td>
              <td className="users-table-cell um-col-phone">{user.phone_number || 'Не вказано'}</td>
              <td className="users-table-cell um-col-status">
                <span className={`users-table-status-badge ${user.is_active ? 'active' : 'inactive'}`}>
                  {user.is_active ? 'Активний' : 'Неактивний'}
                </span>
              </td>
              <td className="users-table-cell um-col-notifications">
                {user.role === 'Administrator' && (
                  <span className={`users-table-notification-badge ${user.notify ? 'enabled' : 'disabled'}`}>
                    {user.notify ? 'Увімкнено' : 'Вимкнено'}
                  </span>
                )}
              </td>
              <td className="users-table-cell um-col-created">{formatToLocalDateTimeShort(user.created_at)}</td>
              <td className="users-table-cell um-col-actions">
                <div className="users-table-action-buttons">
                  <IconButton
                    onClick={() => onEdit(user)}
                    disabled={isLoading}
                    size="small"
                    className="users-table-edit-button"
                  >
                    <Edit sx={{ fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => onDelete(user)}
                    disabled={isLoading}
                    size="small"
                    className="users-table-delete-button"
                  >
                    <Delete sx={{ fontSize: '1rem' }} />
                  </IconButton>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
